<template>
  <v-container grid-list-xl>
    <v-layout row wrap>
      <docket-control></docket-control>
      <docket-view></docket-view>
    </v-layout>
  </v-container>
</template>

<script>
import Store from "@/store/computed/storeHelpers";
import DocketControl from "@/components/dockets/docketControl";
import DocketView from "@/components/dockets/docketView";
export default {
  components: {
    DocketView,
    DocketControl
  },
  methods: {}
};
</script>

<style>
</style>
